module.exports = __webpack_public_path__ + "static/media/done_all.ce4a0201.svg";